export const mainnav = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
   * Add nav-open class on body tag when mainmenu is open
   */
  const menuToggle = document.getElementById('input__menu-toggle');

  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      // toggle document.getElementsByTagName('html')[0].classList.add('nav-open');
      document.getElementsByTagName('html')[0].classList.toggle('nav-open');
    });
  }

  /*
   * Close menu if clicked link has same url as current page url
   */
  const menuLinks = document.querySelectorAll(
    '.nav-primary .nav > .menu-item > a',
  );

  menuLinks.forEach((link) => {
    link.addEventListener('click', () => {
      //console.log(link.href, window.location.href);
      // if link has hashtag in href close the menu and remove nav-open class from html tag

      if (link.href === window.location.href || link.href.includes('#')) {
        //e.preventDefault();
        //e.stopPropagation();
        // add class is-closing to html tag for animation on closing menu
        document.getElementsByTagName('html')[0].classList.add('is-closing');

        // remove class active from menu items for animation on closing menu
        const menuItems = document.querySelectorAll(
          '.nav-primary .nav > .menu-item > a',
        );
        menuItems.forEach((item) => {
          item.classList.remove('sliding-in');
          item.parentElement.classList.remove('show-illustration');
        });

        setTimeout(() => {
          document
            .getElementsByTagName('html')[0]
            .classList.remove('is-closing');
          // remove class hide-scrollbar after nav closing animation duration to show scrollbar again
          document
            .getElementsByTagName('html')[0]
            .classList.remove('hide-scrollbar');

          document.getElementsByTagName('html')[0].classList.remove('nav-open');
        }, 600);
        document.getElementsByTagName('html')[0].classList.remove('nav-open');
        document
          .getElementsByTagName('html')[0]
          .classList.remove('hide-scrollbar');
      }
    });
  });

  /*
   * Add class fixed navigation on scrolling down
   * and show fixed header with animation when scrolling down and hide it when scrolling up by adding class slide-down and slide-up
   */

  /*   const handleScrollPage = () => {
    const currentY = window.scrollY || 0;

    // toggle fixed-nav when scrolled a little
    if (currentY > 100) {
      document.documentElement.classList.add('fixed-nav');
      setTimeout(() => {
        document.documentElement.classList.add('is-sticky');
      }, 300);
    } else {
      document.documentElement.classList.remove('is-sticky');
      document.documentElement.classList.remove('fixed-nav');
    }
  };

  window.addEventListener('scroll', handleScrollPage); */
};

import.meta.webpackHot?.accept(mainnav);
